import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import {
  GetVoucherByCorporateClientResponse,
  GetVoucherByCorporateClientParams,
  GetVouchersParams,
  GetVouchersResponse,
  GetStartkitVouchersParams,
  GetStartkitVouchersResponse,
  GetDistancesByVoucherParams,
  GetDistancesByVoucherResponse,
  GetVouchersPromocodesParams,
  GetVouchersPromocodesResponse,
  GetVouchersPromocodesFreeParams,
  GetVouchersPromocodesFreeResponse,
  GetVouchersUsersPromocodesParams,
  GetVouchersUsersPromocodesResponse,
  GetVouchersByIdParams,
  GetVouchersByIdResponse,
  GetVouchersCorpStartkitParams,
  GetVouchersCorpStartkitResponse,
  GetVouchersPromocodesByIdParams,
  GetVouchersPromocodesByIdResponse,
  GetVouchersPromocodesUnassignedCountPerDistanceParams,
  GetVouchersPromocodesUnassignedCountPerDistanceResponse,
  GetSubvouchersParams,
  GetSubvouchersResponse,
  PostVouchersBody,
  PostVouchersResponse,
  PostVouchersPromocodesBody,
  PostVouchersAssignPromocodeByEmailParams,
  PostVouchersPromocodeUnassignParams,
  PostVouchersSubvoucherBody,
  PutVouchersBody,
  PutVouchersResponsibleUserParams,
  PutVouchersSubvouchersBody,
  PatchVouchersChangeStatusParams,
  DeleteVouchersPromocodesParams,
  DeleteVouchersParams,
  DeleteVouchersNonActivatedPromocodesParams,
  DeleteVouchersSubvouchersParams,
  GetVouchersExcelParams,
  GetVouchersExportVoucherReportToExcelParams
} from "./types";
import { List } from "api/slice/types";

export const VouchersAPI = {
  getVouchers: async (
    params: GetVouchersParams
  ): Promise<List<GetVouchersResponse>> => {
    const response = await axiosApi.get<List<GetVouchersResponse>>("/vouchers", {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
    return response.data;
  },
  getVoucherByCorporateClient: async (
    params: GetVoucherByCorporateClientParams
  ): Promise<GetVoucherByCorporateClientResponse> => {
    const response = await axiosApi.get<GetVoucherByCorporateClientResponse>(
      "/vouchers/voucherbycorporateclient",
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getStartkitVouchers: async ({
    marathonId,
    ...params
  }: GetStartkitVouchersParams): Promise<GetStartkitVouchersResponse> => {
    const response = await axiosApi.get<GetStartkitVouchersResponse>(
      `/vouchers/startkit/${marathonId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getDistancesByVoucher: async ({
    voucherId,
    ...params
  }: GetDistancesByVoucherParams): Promise<GetDistancesByVoucherResponse> => {
    const response = await axiosApi.get<GetDistancesByVoucherResponse>(
      `/vouchers/${voucherId}/distancesbyvoucher`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getVouchersPromocodes: async ({
    voucherId,
    ...params
  }: GetVouchersPromocodesParams): Promise<GetVouchersPromocodesResponse> => {
    const response = await axiosApi.get<GetVouchersPromocodesResponse>(
      `/vouchers/${voucherId}/promocodes`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getVouchersPromocodesFree: async ({
    voucherId,
    ...params
  }: GetVouchersPromocodesFreeParams): Promise<GetVouchersPromocodesFreeResponse> => {
    const response = await axiosApi.get<GetVouchersPromocodesFreeResponse>(
      `/vouchers/${voucherId}/promocodes/free`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getVouchersUsersPromocodes: async ({
    userId,
    ...params
  }: GetVouchersUsersPromocodesParams): Promise<GetVouchersUsersPromocodesResponse> => {
    const response = await axiosApi.get<GetVouchersUsersPromocodesResponse>(
      `/vouchers/promocodes/users/${userId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getVouchersById: async ({
    voucherId,
    ...params
  }: GetVouchersByIdParams): Promise<GetVouchersByIdResponse> => {
    const response = await axiosApi.get<GetVouchersByIdResponse>(
      `/vouchers/${voucherId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getVouchersCorpStartkit: async ({
    voucherId,
    ...params
  }: GetVouchersCorpStartkitParams): Promise<GetVouchersCorpStartkitResponse> => {
    const response = await axiosApi.get<GetVouchersCorpStartkitResponse>(
      `/vouchers/corp-startkit/${voucherId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getVouchersPromocodesById: async ({
    promocodeId,
    ...params
  }: GetVouchersPromocodesByIdParams): Promise<GetVouchersPromocodesByIdResponse> => {
    const response = await axiosApi.get<GetVouchersPromocodesByIdResponse>(
      `/vouchers/promocodes/${promocodeId}`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getVouchersPromocodesUnassignedCountPerDistance: async ({
    voucherId,
    ...params
  }: GetVouchersPromocodesUnassignedCountPerDistanceParams): Promise<GetVouchersPromocodesUnassignedCountPerDistanceResponse> => {
    const response =
      await axiosApi.get<GetVouchersPromocodesUnassignedCountPerDistanceResponse>(
        `/vouchers/${voucherId}/promoCodes/unassignedCountPerDistance`,
        {
          params,
          headers: {
            "Accept-Language": checkCurrentLanguage(),
          },
        }
      );
    return response.data;
  },
  getSubvouchers: async ({
    voucherId,
    ...params
  }: GetSubvouchersParams): Promise<GetSubvouchersResponse> => {
    const response = await axiosApi.get<GetSubvouchersResponse>(
      `/vouchers/${voucherId}/subvouchers`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postVouchers: async (
    body: PostVouchersBody
  ): Promise<PostVouchersResponse> => {
    const response = await axiosApi.post<PostVouchersResponse>(
      `/vouchers`,
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postVouchersPromocodes: async ({
    voucherId,
    ...body
  }: PostVouchersPromocodesBody): Promise<void> => {
    await axiosApi.post(
      `/vouchers/${voucherId}/promocodes`,
      { promocodes: body.promocodes },
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
  },
  postVouchersAssignPromocodeByEmail: async (
    params: PostVouchersAssignPromocodeByEmailParams
  ): Promise<void> => {
    await axiosApi.post<void>("/vouchers/assignpromocodebyemail", {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  postVouchersPromocodeUnassign: async ({
    promocodeId,
    ...params
  }: PostVouchersPromocodeUnassignParams): Promise<void> => {
    await axiosApi.post<void>(`/vouchers/promocode/unassign/${promocodeId}`, {
      params,
      headers: { "Accept-Language": checkCurrentLanguage() },
    });
  },
  postVouchersSubvoucher: async (
    body: PostVouchersSubvoucherBody
  ): Promise<void> => {
    await axiosApi.post<void>(`/vouchers/subvoucher`, body, {
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  putVouchers: async (body: PutVouchersBody): Promise<void> => {
    await axiosApi.put<void>(`/vouchers`, body, {
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  putVouchersResponsibleUser: async ({
    voucherId,
    ...params
  }: PutVouchersResponsibleUserParams): Promise<void> => {
    await axiosApi.put<void>(`/vouchers/${voucherId}/responsibleUser`, params, {
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  putVouchersSubvouchers: async (
    body: PutVouchersSubvouchersBody
  ): Promise<void> => {
    await axiosApi.put<void>(`/vouchers/subvouchers`, body, {
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  patchVouchersChangeStatus: async ({
    voucherId,
    ...params
  }: PatchVouchersChangeStatusParams): Promise<void> => {
    await axiosApi.patch<void>(`/vouchers/${voucherId}/changeStatus`, params, {
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  deleteVouchersPromocodes: async ({
    voucherId,
    ...params
  }: DeleteVouchersPromocodesParams): Promise<void> => {
    await axiosApi.delete<void>(`/vouchers/${voucherId}/promocodes`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  deleteVouchers: async ({
    voucherId,
    ...params
  }: DeleteVouchersParams): Promise<void> => {
    await axiosApi.delete<void>(`/vouchers/${voucherId}`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  deleteVouchersNonActivatedPromocodes: async ({
    voucherId,
    ...params
  }: DeleteVouchersNonActivatedPromocodesParams): Promise<void> => {
    await axiosApi.delete<void>(`/vouchers/${voucherId}/non-activated-promocodes`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  deleteVouchersSubvouchers: async ({
    subVoucherId,
    ...params
  }: DeleteVouchersSubvouchersParams): Promise<void> => {
    await axiosApi.delete<void>(`/vouchers/subvouchers/${subVoucherId}`, {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
  },
  getVouchersExcel: async ({
    voucherId,
    ...params
  }: GetVouchersExcelParams): Promise<void> => {
    const response = await axiosApi.get<void>(
      `/vouchers/${voucherId}/excel`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getVouchersExportVoucherReportToExcel: async ({
    voucherId,
    ...params
  }: GetVouchersExportVoucherReportToExcelParams): Promise<void> => {
    const response = await axiosApi.get<void>(
      `/vouchers/${voucherId}/exportVoucherReportToExcel`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
};
